export default {
  clusterId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  paId: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  nomeAssociado: {
    value: '',
    required: false,
    state: null
  },
  gerenteId: {
    value: null,
    required: false,
    state: null
  },
  isProdutorRural: {
    value: null,
    required: false,
    state: null
  },
  tipoPessoa: {
    value: null,
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/movimentacoes/clusters/link-form.js